import React, { useEffect, useState, createElement, Component } from 'react';
import { CheckCircle2, AlertTriangle, ShieldCheck, ChevronDown, MessageCircle, Lock, Eye, ArrowRight, MailCheck } from 'lucide-react';
import { Footer } from '../components/Footer';
declare global {
  interface Window {
    fbq: any;
    gtag: any;
    dataLayer: any[];
  }
}
// Google Ads conversion tag identifiers.
const GOOGLE_ADS_ID = 'AW-11106102578';
// Purchase conversion event snippet: send_to = AW-11106102578/2gKmCJKkptgbELLa5q8p
const GOOGLE_ADS_PURCHASE_LABEL = 'AW-11106102578/2gKmCJKkptgbELLa5q8p';
const PANDA_VIDEO_ID = '2bc7a3c0-3b7b-4856-adaa-9ce26a0e50bd';
const FAQS = [{
  q: '¿Es una llamada de venta? ¿Me van a ofrecer otro producto?',
  a: 'No. Ya compraste el programa. El onboarding es para activarte: te asignamos nicho, te metemos en la comunidad y te armamos tu plan de 7 días. Cero pitch.'
}, {
  q: '¿Qué pasa si no puedo agendar esta semana?',
  a: 'Podés agendar hasta 7 días en el futuro. Pero te recomiendo agendar lo antes posible — cada día que no arrancás es un día perdido. Los alumnos que cierran rápido son los que agendan en las primeras 24 horas.'
}, {
  q: '¿Y si no asisto a la llamada?',
  a: 'Tu acceso al programa ya está activo. Pero sin el onboarding vas a ir a ciegas — vas a tomar 2-3 días para decidir cosas que en la llamada se deciden en minutos. Te recomiendo asistir.'
}];
type Step = {
  number: string;
  title: string;
  desc: string;
  ctaLabel?: string;
  ctaHref?: string;
};
const STEPS: Step[] = [{
  number: '01',
  title: 'Revisá tu email y SMS para tu acceso',
  desc: 'Te enviamos tus datos de acceso por email y mensaje de texto. Revisá tu bandeja de entrada (y spam) para entrar.'
}, {
  number: '02',
  title: 'Activá HeyLloyd y empezá a generar en las próximas 48 horas',
  desc: 'Entrá a HeyLloyd y poné en marcha tu sistema para empezar a generar en las próximas 48 horas.',
  ctaLabel: 'Activar HeyLloyd',
  ctaHref: 'https://app.heylloyd.io/web-checkout'
}];
export function PurchaseBookACallWebinarPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  // Buyer's email, read from the redirect URL (Fanbasis appends ?email= / ?em=).
  const [customerEmail, setCustomerEmail] = useState<string>('');
  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const em = params.get('email') || params.get('em') || '';
      if (em && em.includes('@')) setCustomerEmail(em);
    } catch {
      /* ignore — email chip just won't render */
    }
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
    // ── Google Tag Manager (GTM-MJLLJMZD) ────────────────────────────────────
    // Injected as high as possible so GTM boots before the rest of the page's
    // tags. This mirrors the standard GTM <head> snippet. Guarded so it only
    // initialises once per page load even if the effect re-runs.
    if (!(window as any).__gtmLoaded) {
      ;
      (window as any).__gtmLoaded = true;
      (function (w: any, d: any, s: any, l: any, i: any) {
        w[l] = w[l] || [];
        w[l].push({
          'gtm.start': new Date().getTime(),
          event: 'gtm.js'
        });
        const f = d.getElementsByTagName(s)[0];
        const j = d.createElement(s);
        const dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        if (f && f.parentNode) {
          f.parentNode.insertBefore(j, f);
        } else {
          d.head.appendChild(j);
        }
      })(window, document, 'script', 'dataLayer', 'GTM-MJLLJMZD');
    }
    // Panda Video preconnect for faster player load
    const preconnect1 = document.createElement('link');
    preconnect1.rel = 'preconnect';
    preconnect1.href = 'https://player-vz-cf0b871f-7fe.tv.pandavideo.com';
    preconnect1.crossOrigin = 'anonymous';
    document.head.appendChild(preconnect1);
    // LeadConnector booking embed script
    const formEmbedScript = document.createElement('script');
    formEmbedScript.src = 'https://link.msgsndr.com/js/form_embed.js';
    formEmbedScript.type = 'text/javascript';
    formEmbedScript.async = true;
    document.head.appendChild(formEmbedScript);
    // PIXEL BOOTSTRAP — browser-side Meta Pixel base library + PageView.
    // IMPORTANT: this page can be served on a host where the global App.tsx
    // pixel bootstrap does NOT run (e.g. confirmation.ingresahoy.com), so the
    // Meta Pixel Helper reported "No Pixels found on this page". We therefore
    // load the Meta Pixel BASE LIBRARY here ourselves (the standard fbevents.js
    // snippet) instead of assuming window.fbq already exists. This snippet is
    // safe to run even if fbq is already present — it no-ops on `if (f.fbq) return`.
    //
    // We initialise THREE pixels and fire a PageView on each:
    //   - 754551913878347 (global / main)
    //   - 2842475396100201 (48Hrs VSL)
    //   - 2826493141057409 (additional)
    //
    // NOTE: the browser-side Meta Purchase event has been intentionally REMOVED.
    // The Purchase is now fired server-side via CAPI (Zapier → Heylloyd CAPI)
    // so it can carry the real, DYNAMIC order amount instead of a hardcoded
    // $297. Do not re-add a browser Purchase here — it would send a fixed value
    // and could double-count against the CAPI event.
    const GLOBAL_PIXEL_ID = '754551913878347';
    const VSL_PIXEL_ID = '2842475396100201'; // 48Hrs VSL
    const EXTRA_PIXEL_ID = '2826493141057409' // additional
;
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    // 2) Init BOTH pixels and fire a PageView for each. fbq queues these calls
    //    until fbevents.js finishes loading, so they run reliably even though
    //    the library loads asynchronously.
    window.fbq('init', GLOBAL_PIXEL_ID);
    window.fbq('init', VSL_PIXEL_ID);
    window.fbq('init', EXTRA_PIXEL_ID);
    window.fbq('trackSingle', GLOBAL_PIXEL_ID, 'PageView');
    window.fbq('trackSingle', VSL_PIXEL_ID, 'PageView');
    window.fbq('trackSingle', EXTRA_PIXEL_ID, 'PageView');
    // NOTE: no browser-side Meta Purchase is fired here on purpose — see the
    // comment above. The Meta Purchase (with its dynamic amount) is sent
    // server-side via the Heylloyd CAPI relay below, fed by Zapier.
    // ── Google Ads Purchase conversion (AW-11106102578) ──────────────────────
    // Loads the Google Ads global site tag (gtag.js) and fires the Purchase
    // conversion. Fully isolated in try/catch so a failure can never break the
    // page or the other tags. The conversion VALUE and TRANSACTION_ID are read
    // dynamically from the redirect URL params (same params the CAPI relay uses)
    // so Google records the real order amount and can de-duplicate repeat loads
    // by transaction_id. A localStorage guard also prevents refresh/Back re-fires.
    try {
      const gaParams = new URLSearchParams(window.location.search);
      const gaValue = parseFloat(gaParams.get('product_price') || gaParams.get('amount') || gaParams.get('total') || '0');
      const gaTransactionId = gaParams.get('payment_id') || gaParams.get('order_id') || gaParams.get('transaction_id') || '';
      // Load gtag.js once.
      if (!(window as any).__googleAdsLoaded) {
        ;
        (window as any).__googleAdsLoaded = true;
        const gtagScript = document.createElement('script');
        gtagScript.async = true;
        gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + GOOGLE_ADS_ID;
        document.head.appendChild(gtagScript);
        window.dataLayer = window.dataLayer || [];
        window.gtag = function () {
          // eslint-disable-next-line prefer-rest-params
          window.dataLayer.push(arguments);
        };
        window.gtag('js', new Date());
        window.gtag('config', GOOGLE_ADS_ID);
      }
      // Fire the Purchase conversion exactly once per browser.
      let adsAlreadyFired = false;
      try {
        adsAlreadyFired = localStorage.getItem('pbacw_google_ads_fired') === '1';
      } catch {
        adsAlreadyFired = false;
      }
      if (!adsAlreadyFired && typeof window.gtag === 'function') {
        window.gtag('event', 'conversion', {
          send_to: GOOGLE_ADS_PURCHASE_LABEL,
          value: isNaN(gaValue) || gaValue <= 0 ? 1.0 : gaValue,
          currency: 'USD',
          transaction_id: gaTransactionId
        });
        try {
          localStorage.setItem('pbacw_google_ads_fired', '1');
        } catch {
          /* localStorage unavailable — best effort */
        }
      }
    } catch {
      /* never let the Google Ads tag break the page */
    }
    // ── Heylloyd CAPI Fire ───────────────────────────────────────────────────
    // Fires a Purchase to Heylloyd's CAPI endpoint via fetch(). Fully isolated
    // from the Meta Pixel logic above — wrapped in try/catch so a failure here
    // can NEVER break the page or the pixels. Guarded by a fire-once flag so it
    // does not re-fire on refresh / Back navigation.
    try {
      let capiAlreadyFired = false;
      try {
        capiAlreadyFired = localStorage.getItem('pbacw_capi_fired') === '1';
      } catch {
        capiAlreadyFired = false;
      }
      if (!capiAlreadyFired) {
        const params = new URLSearchParams(window.location.search);
        const affiliate = params.get('affiliate') || params.get('ref') || 'direct';
        const amount = params.get('product_price') || params.get('amount') || params.get('total') || '27';
        const orderId = params.get('payment_id') || params.get('order_id') || params.get('transaction_id') || 'fb_' + Date.now();
        const email = params.get('email') || '';
        const phone = params.get('phone') || '';
        const fullName = params.get('name') || '';
        const firstName = params.get('first_name') || fullName.split(' ')[0] || '';
        const lastName = params.get('last_name') || fullName.split(' ').slice(1).join(' ') || '';
        const getCookie = (n: string) => {
          const m = document.cookie.match(new RegExp('(^| )' + n + '=([^;]+)'));
          return m ? decodeURIComponent(m[2]) : '';
        };
        const fbp = getCookie('_fbp');
        const fbc = getCookie('_fbc');
        const fbclid = params.get('fbclid') || '';
        let capiUrl = 'https://heylloydcrm.com/api/capi/fire' + '?affiliate=' + encodeURIComponent(affiliate) + '&amount=' + encodeURIComponent(amount) + '&currency=USD' + '&order_id=' + encodeURIComponent(orderId) + '&page_url=' + encodeURIComponent(window.location.href);
        if (email) capiUrl += '&em=' + encodeURIComponent(email);
        if (phone) capiUrl += '&ph=' + encodeURIComponent(phone);
        if (firstName) capiUrl += '&fn=' + encodeURIComponent(firstName);
        if (lastName) capiUrl += '&ln=' + encodeURIComponent(lastName);
        if (fbp) capiUrl += '&fbp=' + encodeURIComponent(fbp);
        if (fbc) capiUrl += '&fbc=' + encodeURIComponent(fbc);
        if (fbclid) capiUrl += '&fbclid=' + encodeURIComponent(fbclid);
        fetch(capiUrl).catch(function () {});
        try {
          localStorage.setItem('pbacw_capi_fired', '1');
        } catch {
          /* localStorage unavailable — best effort */
        }
      }
    } catch {
      /* never let CAPI relay break the page */
    }
    // ── HeyLloyd Conversion Pixel ────────────────────────────────────────────
    // Reports the conversion back to HeyLloyd's click-tracking endpoint using
    // the click id (cid). The cid comes from the URL (?cid=...) or, as a
    // fallback, from localStorage where it was stashed on an earlier page.
    // Isolated in try/catch so it can never break the page or other tags.
    try {
      const cid = new URLSearchParams(window.location.search).get('cid') || localStorage.getItem('hl_cid');
      if (cid) {
        console.log('[HeyLloyd Conversion Pixel] firing for cid:', cid);
        fetch('https://3000-i2zfhqgftgepb164zicho-fcdc7a09.us1.manus.computer/api/track/conversion', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            clickId: cid,
            revenue: 27
          }),
          // keepalive lets the request finish even if the page navigates away
          // right after the conversion is recorded.
          keepalive: true
        }).catch(function () {});
        try {
          localStorage.removeItem('hl_cid');
        } catch {
          /* localStorage unavailable — best effort */
        }
      } else {
        console.log('[HeyLloyd Conversion Pixel] no cid found (checked ?cid= and localStorage hl_cid) — not firing');
      }
    } catch {
      /* never let the HeyLloyd conversion pixel break the page */
    }
    return () => {
      if (document.head.contains(preconnect1)) document.head.removeChild(preconnect1);
      if (document.head.contains(formEmbedScript)) document.head.removeChild(formEmbedScript);
    };
  }, []);
  return <div className="min-h-screen bg-[#0a1428] text-white font-sans selection:bg-[#00f7fc]/30 selection:text-white overflow-x-hidden" data-id="element-4232" data-mp="1fdym82idfrnq">
      {/* Google Tag Manager (noscript) — GTM-MJLLJMZD */}
      <noscript data-id="element-4233" data-mp="27vktj5oyw63e">
        <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-MJLLJMZD" height="0" width="0" style={{
        display: 'none',
        visibility: 'hidden'
      }} title="Google Tag Manager" data-id="element-4234" data-mp="27w2v8huefcip" />
      </noscript>
      {/* End Google Tag Manager (noscript) */}

      {/* Background ambient glows */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[900px] h-[600px] bg-[#00f7fc]/[0.06] blur-[140px] rounded-full pointer-events-none" data-id="element-4235" data-mp="1rppy3unhodje" />
      <div className="absolute top-[40%] right-0 w-[500px] h-[500px] bg-emerald-400/[0.04] blur-[120px] rounded-full pointer-events-none" data-id="element-4236" data-mp="1in87z54pr0r4" />
      <div className="absolute inset-0 opacity-[0.015] pointer-events-none" style={{
      backgroundImage: 'linear-gradient(rgba(255,255,255,0.4) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.4) 1px, transparent 1px)',
      backgroundSize: '60px 60px'
    }} data-id="element-4237" data-mp="26edo7lekfv1y" />

      <main className="relative z-10 max-w-5xl mx-auto px-4 lg:px-8 pt-6 md:pt-16 pb-10 md:pb-12" data-id="element-4238" data-mp="21lasp7q8abj4">
        {/* ============ BLOCK 1 — CONFIRMATION ============ */}
        <section className="text-center mb-8 md:mb-16" data-id="element-4239" data-mp="2u2n6idckm0oc">
          <div className="inline-flex items-center gap-1.5 bg-emerald-500/15 border border-emerald-500/40 rounded-full px-3 py-1 md:px-4 md:py-1.5 mb-4 md:mb-6" data-id="element-4240" data-mp="2u47z3xfbr9jk">
            <CheckCircle2 className="w-3 h-3 md:w-3.5 md:h-3.5 text-emerald-400" data-id="element-4241" data-mp="dp37p9owl66h" />
            <span className="text-emerald-400 text-[10px] md:text-xs font-black uppercase tracking-[0.16em] leading-none" data-id="element-4242" data-mp="rfqape1p5i8d">
              Pago Confirmado
            </span>
          </div>

          <h1 className="text-[1.75rem] md:text-5xl lg:text-[4rem] font-black leading-[1.05] tracking-tight mb-3 md:mb-6 max-w-4xl mx-auto" data-id="element-4243" data-mp="3vu6k7fh78kgx">
            ¡Bienvenido al{' '}
            <span className="text-[#00f7fc]" data-id="element-4244" data-mp="3qwxy53sxjwae">48 Hrs AI Cash Machine!</span>
          </h1>

          <p className="text-sm md:text-lg lg:text-xl text-gray-400 max-w-2xl mx-auto leading-relaxed" data-id="element-4245" data-mp="8r1p0pve38vj">
            Tu compra está confirmada. Ahora hay{' '}
            <span className="text-white font-semibold" data-id="element-4246" data-mp="1k445lkxhnyfp">UN último paso</span>{' '}
            para activar tu acceso completo: agendar tu onboarding de{' '}
            <span className="text-white font-semibold" data-id="element-4247" data-mp="1f7n7pz0hm5pf">20 minutos</span>.
          </p>

          {customerEmail && <div className="mt-5 md:mt-7 flex justify-center" data-id="element-4248" data-mp="cuh9j84b5cqa">
              <div className="inline-flex flex-wrap items-center justify-center gap-2 bg-white/[0.04] border border-[#00f7fc]/25 rounded-full px-4 py-2 md:px-5 md:py-2.5 max-w-full" data-id="element-4249" data-mp="hpwj3nva8mgw">
                <MailCheck className="w-4 h-4 md:w-[18px] md:h-[18px] text-[#00f7fc] flex-shrink-0" data-id="element-4250" data-mp="qqureicr7g5a" />
                <span className="text-gray-400 text-xs md:text-sm" data-id="element-4251" data-mp="3q82g0bfq408w">
                  Enviamos tu acceso a{' '}
                </span>
                <span className="text-white text-xs md:text-sm font-black break-all" data-id="element-4252" data-mp="3u6jq93ufxquj">
                  {customerEmail}
                </span>
              </div>
            </div>}
        </section>

        {/* ============ BLOCK 2 — VIDEO ============ */}
        <section className="mb-10 md:mb-24" data-id="element-4253" data-mp="36jtom3m07yag">
          <div className="text-center mb-4 md:mb-8" data-id="element-4254" data-mp="36gz6wjudkrkq">
            <div className="inline-flex items-center gap-1.5 md:gap-2 mb-2 md:mb-4" data-id="element-4255" data-mp="3bhd394mm6d2x">
              <Eye className="w-3.5 h-3.5 md:w-4 md:h-4 text-[#00f7fc]" data-id="element-4256" data-mp="33z5gmd4hkpbf" />
              <span className="text-[#00f7fc] text-[10px] md:text-sm font-black uppercase tracking-[0.16em] md:tracking-[0.18em]" data-id="element-4257" data-mp="33w9h4kczpskv">
                Mirá Este Video Antes De Bajar
              </span>
            </div>
            <h2 className="text-lg md:text-3xl lg:text-4xl font-black leading-tight max-w-3xl mx-auto" data-id="element-4258" data-mp="2pz4fcwkb7fvf">
              Gabriel tiene <span className="text-[#00f7fc]" data-id="element-4259" data-mp="2l018r7ool1lc">90 segundos</span>{' '}
              para vos antes de que sigas.
            </h2>
          </div>

          <div className="max-w-4xl mx-auto" data-id="element-4260" data-mp="2g6ye0w863m3k">
            <div className="relative overflow-hidden border border-[#00f7fc]/30 shadow-2xl bg-gray-900" style={{
            boxShadow: '0 0 30px rgba(0, 247, 252, 0.15), 0 0 60px rgba(0, 247, 252, 0.08)',
            paddingTop: '56.25%'
          }} data-id="element-4261" data-mp="2b96o27r32a20">
              <iframe id={`panda-${PANDA_VIDEO_ID}`} src={`https://player-vz-cf0b871f-7fe.tv.pandavideo.com/embed/?v=${PANDA_VIDEO_ID}`} title="Mensaje de Gabriel" className="absolute inset-0 w-full h-full" style={{
              border: 'none'
            }} allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture" allowFullScreen data-id="element-4262" data-mp="22bcrqwtbjgeu" />
            </div>

            <p className="text-center text-gray-400 text-[11px] md:text-sm mt-3 md:mt-4 leading-relaxed" data-id="element-4263" data-mp="3c5f3rdcqgczl">
              Reproducí el video. Después agendá tu llamada abajo.
            </p>
          </div>
        </section>

        {/* ============ BLOCK 3 — 3 STEPS ============ */}
        <section className="mb-10 md:mb-24" data-id="element-4264" data-mp="3785epyt9a3ca">
          <div className="text-center mb-6 md:mb-14" data-id="element-4265" data-mp="3796ntxqpofrd">
            <h2 className="text-xl md:text-4xl lg:text-5xl font-black leading-tight max-w-3xl mx-auto" data-id="element-4266" data-mp="2sj8vr6pnv5ww">
              Cómo arranca tu{' '}
              <span className="text-[#00f7fc]" data-id="element-4267" data-mp="2xf7t3jsyvy9g">sprint de 7 días</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-6 max-w-5xl mx-auto" data-id="element-4268" data-mp="2jjm3pbitncgi">
            {STEPS.map(s => <div key={s.number} className="relative flex flex-col bg-white/[0.025] border border-white/[0.08] rounded-xl md:rounded-2xl p-4 md:p-7 lg:p-8 hover:border-[#00f7fc]/40 hover:bg-white/[0.04] transition-all duration-300" data-id="element-4269" data-mp="2oifcwrr2shav">
                <div className="text-4xl md:text-6xl lg:text-7xl font-black text-[#00f7fc] leading-none mb-2.5 md:mb-5 tracking-tight" data-id="element-4270" data-mp="2dvr0eyxznnn5">
                  {s.number}
                </div>
                <h3 className="text-base md:text-xl font-black text-white mb-1.5 md:mb-3 leading-snug" data-id="element-4271" data-mp="2nt54dz2q6jyk">
                  {s.title}
                </h3>
                <p className="text-sm md:text-base text-gray-400 leading-relaxed" data-id="element-4272" data-mp="2iubsgb33710i">
                  {s.desc}
                </p>
                {s.number === '01' && customerEmail && <div className="mt-3 md:mt-4 flex items-center gap-2 bg-[#00f7fc]/[0.06] border border-[#00f7fc]/20 rounded-lg px-3 py-2" data-id="element-4273" data-mp="2slg697h10ftr">
                    <MailCheck className="w-4 h-4 text-[#00f7fc] flex-shrink-0" data-id="element-4274" data-mp="36htmyedqkd76" />
                    <span className="text-white text-xs md:text-sm font-bold break-all" data-id="element-4275" data-mp="31mwh1gbr6jyi">
                      {customerEmail}
                    </span>
                  </div>}
                {s.ctaLabel && s.ctaHref && <a href={s.ctaHref} target="_blank" rel="noopener noreferrer" className="group mt-4 md:mt-6 inline-flex items-center justify-center gap-2 w-full bg-[#00f7fc] hover:bg-[#33f9fd] text-[#0a1428] font-black text-sm md:text-base uppercase tracking-tight rounded-lg md:rounded-xl py-3 md:py-3.5 px-5 transition-all duration-300" data-id="element-4276" data-mp="3a1y6wuwhwgrn">
                    {s.ctaLabel}
                    <ArrowRight className="w-4 h-4 md:w-5 md:h-5 transition-transform group-hover:translate-x-0.5" data-id="element-4277" data-mp="2qfjr3as5qukm" />
                  </a>}
              </div>)}
          </div>
        </section>

        {/* ============ BLOCK 4 — CALENDAR ============ */}
        

        {/* ============ BLOCK 5 — FAQ ============ */}
        

        {/* ============ BLOCK 6 — FOOTER SUPPORT ============ */}
        <section className="border-t border-white/[0.08] pt-8 md:pt-16" data-id="element-4278" data-mp="27mpl36ciicsj">
          <div className="max-w-3xl mx-auto space-y-5 md:space-y-8" data-id="element-4279" data-mp="n56o5xyq584g">
            {/* Support */}
            <div className="bg-white/[0.025] border border-white/[0.08] rounded-xl md:rounded-2xl p-4 md:p-7" data-id="element-4280" data-mp="rwyj0kowy00e">
              <div className="flex items-start gap-3 mb-1 md:mb-2" data-id="element-4281" data-mp="e5tgnau5utmd">
                <div className="w-9 h-9 md:w-10 md:h-10 rounded-lg md:rounded-xl bg-[#00f7fc]/10 border border-[#00f7fc]/30 flex items-center justify-center flex-shrink-0" data-id="element-4282" data-mp="i6lqo6aux2jp">
                  <MessageCircle className="w-4 h-4 text-[#00f7fc]" data-id="element-4283" data-mp="15u3l69liaeqd" />
                </div>
                <div className="flex-1" data-id="element-4284" data-mp="1auhuduyufupz">
                  <h3 className="text-sm md:text-lg font-black text-white mb-1.5 md:mb-2" data-id="element-4285" data-mp="wvrvc9sgrkyz">
                    ¿No podés acceder al curso?
                  </h3>
                  <p className="text-[13px] md:text-base text-gray-400 leading-relaxed" data-id="element-4286" data-mp="11srv62ypzrhn">
                    Si tenés problemas para entrar o activar tu acceso,
                    escribinos a{' '}
                    <a href="mailto:soporte@truemarketer.com" className="text-[#00f7fc] hover:underline font-semibold break-all" data-id="element-4287" data-mp="3miqwvup694bt">
                      soporte@truemarketer.com
                    </a>{' '}
                    y te ayudamos enseguida. Te respondemos en menos de 4 horas
                    en horario laboral.
                  </p>
                </div>
              </div>
            </div>

            {/* Legals */}
            <div className="text-center pt-2 md:pt-4" data-id="element-4288" data-mp="19dub7bhuaaep">
              <p className="text-[10px] md:text-xs text-gray-600 leading-relaxed" data-id="element-4289" data-mp="19ff4yywbxpbi">
                &copy; 2026 Gabriel Beltrán · 48 Hrs AI Cash Machine ·{' '}
                <a href="/terms" className="hover:text-gray-400 transition-colors" data-id="element-4290" data-mp="zf64h8vb1hqb">
                  Términos
                </a>{' '}
                ·{' '}
                <a href="/privacy" className="hover:text-gray-400 transition-colors" data-id="element-4291" data-mp="vgp7hi5llnmm">
                  Privacidad
                </a>
              </p>
            </div>
          </div>
        </section>
      </main>
    </div>;
}